require("./_mark");

var product_categories = require("../_product-categories");
var products = require("../_products");
var product_subcategories = require("../_product-subcategories");
var numberProductResult = 0;

var keyup_timeout;

$("#search-input").on("keyup", function() {
	$input = $(this);

	if (keyup_timeout) clearTimeout(keyup_timeout);

	keyup_timeout = setTimeout(function() {
		if ($input.val().length >= 2) {
			findResultSearch($input.val().toLowerCase());
		}
	}, 500);
});

$("#search-img, .search-icon").on("click tap", function() {
	if ($(".search-container").hasClass("open")) {
		$(".search-container").removeClass("open");
		$(".back-black").fadeOut("fast");
		return;
	}
	$(".back-black").fadeIn("fast");
	$(".search-container").addClass("open");
	$(".search-container #search-input").focus();
});
$(".close-search-box").on("click tap", function() {
	if ($(".search-container").hasClass("open")) {
		$(".search-container").removeClass("open");
		$(".back-black").fadeOut("fast");
		return;
	}
});
$(".search-container #search-result ").on(
	"mouseenter",
	".products .object",
	function() {
		if ($(this).hasClass("empty")) {
			return;
		} else {
			$(".search-container #search-result .products").append(
				'<div class="jolly" data-url="' + $(this).data("url") + '"></div>'
			);
			$(".search-container .jolly").css({
				top: $(this).position().top + "px",
				left: $(this).position().left + "px",
				width: $(this).width() + 5 + "px",
				height: $(this).height() + 5 + "px"
			});
		}
	}
);
$(".search-container").on("mouseleave", ".jolly", function() {
	removeJolly();
});
var doneDown = false;
var doneUp = false;
var lastScroll = 0;
$(window).on("scroll", function() {
	removeJolly();
	if ($(window).width() > 1199) {
		var scrollTop = $(window).scrollTop();
		if (scrollTop > lastScroll) {
			// downscroll code
			if (scrollTop > 200 && !doneDown) {
				setTimeout(function functionName() {
					squareBoxProductsSearchResult();
					checkLayoutProductSearchResult();
				}, 350);

				doneDown = true;
				doneUp = false;
			}
		} else {
			if (scrollTop < 190 && !doneUp) {
				setTimeout(function functionName() {
					squareBoxProductsSearchResult();
					checkLayoutProductSearchResult();
				}, 350);
				doneDown = false;
				doneUp = true;
			}
		}
		lastScroll = scrollTop;
	}
});
$(".back-black").on("click tap", function() {
	$(this).fadeOut("fast");
	$(".search-container").removeClass("open");
});
function removeJolly() {
	$(".search-container .jolly").each(function() {
		$(this).remove();
	});
}
$(".search-container #search-result").scroll(function() {
	removeJolly();
});
function findResultSearch(string) {

	var string = string.split(".").join("");
	var result = [];
	var lang = window.location.pathname.split("/")[1];
	var numberCategories = 0;
	var nameProd = "";
	switch (lang) {
		case "it":
			nameProd = "prodotti";
			break;
		case "en":
			nameProd = "products";
			break;
		default:
	}

	/*
	 * Cerca in categorie
	 */
	product_categories.forEach(function(category) {

		var obj = {
			id: category.id,
			type: "categories",
			index: numberCategories,
			link: ""
		};

		// Categories ITA
		if (
			category.acf.category_name_it.toLowerCase().indexOf(string) > -1
		) {
			numberCategories++;
			obj.name = category.acf.category_name_it;
			obj.link +=
				"/it/prodotti/" +
				category.id +
				"/" +
				category.acf.category_name_it
					.split("/,| /")
					.join("-")
					.split("'")
					.join("-")
					.toLowerCase();
			result.push(obj);
			return;
		}

		// Categories EN
		if (
			category.acf.category_name_en.toLowerCase().indexOf(string) > -1
		) {
			numberCategories++;
			obj.name = category.acf.category_name_en;

			obj.link +=
				"/en/products/" +
				category.id +
				"/" +
				category.acf.category_name_en
					.split("/,| /")
					.join("-")
					.split("'")
					.join("-")
					.toLowerCase();

			result.push(obj);
			return;
		}
	});

	/*
	 * Cerca in sotto categorie
	 */
	var numberSubcategories = 0;
	product_subcategories.forEach(function(subcategory) {
		var catId = 0;
		if (subcategory.acf.category_id[0]) {
			catId = subcategory.acf.category_id[0].ID;
		}
		if (!catId) {
			return;
		}
		var catName = getCatName(catId, "cat");
		var obj = {
			id: subcategory.id,
			type: "subcategories",
			index: numberSubcategories,
			link: ""
		};

		// Sub Categorie ITA
		if (
			subcategory.acf.sub_category_name_it.toLowerCase().indexOf(string) > -1
		) {
			numberSubcategories++;
			obj.name = subcategory.acf.sub_category_name_it;
			obj.link +=
				"/it/prodotti/" +
				catId +
				"/" +
				catName.it +
				"/" +
				subcategory.id +
				"/" +
				subcategory.acf.sub_category_name_it
					.split("/,| /")
					.join("-")
					.split("'")
					.join("-")
					.toLowerCase();
			subLinkIt = obj.link;
			result.push(obj);
			return;
		}

		// Sub Categorie EN
		if (
			subcategory.acf.sub_category_name_en.toLowerCase().startsWith(string) ||
			subcategory.acf.sub_category_name_en.toLowerCase().indexOf(string) > 0
		) {
			numberSubcategories++;
			obj.name = subcategory.acf.sub_category_name_en;
			obj.link +=
				"/en/products/" +
				catId +
				"/" +
				catName.en +
				"/" +
				subcategory.id +
				"/" +
				subcategory.acf.sub_category_name_en
					.split("/,| /")
					.join("-")
					.split("'")
					.join("-")
					.toLowerCase();
			result.push(obj);
			return;
		}

	});


	/*
	 * Cerca in prodotti
	 */
	var numberProduct = 0;
	products.forEach(function(product, index) {
		var catId = 0;
		if (product.acf.category_id[0]) {
			catId = product.acf.category_id[0].ID;
		}
		var catName = getCatName(catId, "cat");
		var subId = 0;
		if (product.acf.category_id[0]) {
			subId = product.acf.category_id[0].ID;
		}
		if (!subId) {
			return;
		}

		var subName = getCatName(subId, "sub");
		var link = "/" + lang + "/" + nameProd + "/";
		switch (lang) {
			case "it":
				link +=
					catId +
					"/" +
					catName.it +
					"/" +
					subId +
					"/" +
					subName.it +
					"/" +
					product.acf.product_id;
				break;
			case "en":
				link +=
					catId +
					"/" +
					catName.en +
					"/" +
					subId +
					"/" +
					subName.en +
					"/" +
					product.acf.product_id;
				break;
			default:
		}

		var obj = {
			type: "products",
			name: product.title.rendered,
			index: numberProduct,
			link: link,
			wp_image: product.acf.product_image.url
		};

		if (
			product.title.rendered.toLowerCase().indexOf(string) > -1
		) {
			numberProduct++;
			result.push(obj);
			return;
		}

		var pushed = false;
		result.forEach(function(res) {
			if (
				!pushed &&
				(res.id == product.acf.category_id[0].ID ||
					res.id == product.acf.sub_category_id[0].ID)
			) {
				result.push(obj);
				numberProduct++;
				pushed = true;
				return;
			}
		});
		if (pushed) {
			return;
		}
		if (product.acf.product_variants) {
			var arrVariants = product.acf.product_variants.split(",");

			arrVariants.forEach(function(variant) {
				if (
					variant.startsWith(string) ||
					(variant.indexOf(string) > 0 && !pushed)
				) {
					numberProduct++;
					pushed = true;
					obj.variant = variant;
					result.push(obj);
				}
			});
		}
	});


	/*
	 * Visualizza griglia risultati
	 */

	numberProductResult = numberProduct;
	var html = '<div class="search-result-box">';

	if (result.length) {
		// Found Product
		result.forEach(function(res, index) {
			if (res.index == 0 && index > 0) {
				html += "</div></div>";
			}

			if (res.index == 0) {
				if (res.type == "products") {
					switch (lang) {
						case "it":
							var title = "Prodotti";
							break;
						case "en":
							var title = "Products";
							break;
						default:
					}
					var nameP = res.variant ? res.variant : res.name;
					html +=
						'<div class="box-type ' +
						res.type +
						'"><div class="title"> <span> ' +
						title +
						'</span></div><div class="box-single-result"><div class="object flex-col-center" data-url="' +
						res.link +
						'"><div class="flex-col-center hover" href="/"><div class="name"><span>' +
						nameP +
						'</span></div><div class="img-product" style="background-image: url(/images/categories/' +
						res.name.toLowerCase() +
						"-100px.jpg?prod_image_wp_url=" +
						res.wp_image +
						')"></div></div></div>';
				} else {
					switch (lang) {
						case "it":
							switch (res.type) {
								case "subcategories":
									var title = "Sottocategorie";
									break;
								case "categories":
									var title = "Categorie";
									break;
								default:
							}
							break;
						case "en":
							switch (res.type) {
								case "subcategories":
									var title = "Subcategories";
									break;
								case "categories":
									var title = "Categories";
									break;
								default:
							}
							break;
						default:
					}
					html +=
						'<div class="box-type ' +
						res.type +
						'"><div class="title"><span>' +
						title +
						'</span></div><div class="box-single-result"><div class="object" data-url="' +
						res.link +
						'"><span>' +
						res.name +
						"</span></div>";
				}
			} else {
				if (res.type == "products") {
					var nameP = res.variant ? res.variant : res.name;
					html +=
						'<div class="object flex-col-center" data-url="' +
						res.link +
						'"><div class="flex-col-center hover"><div class="name"><span>' +
						nameP +
						'</span></div><div class="img-product" style="background-image: url(/images/categories/' +
						res.name.toLowerCase() +
						'-100px.jpg)"></div></div></div>';
				} else {
					html +=
						'<div class="object" data-url="' +
						res.link +
						'"><span>' +
						res.name +
						"</span></div></a>";
				}
			}
		});
		html += "</div></div>";
	} else {
		// no result
		html = "";
		html +=
			'<div class="search-result-box flex-col-center no-result"><div class="no-result"><span> Nessun Risultato</span></div>';
	}
	$("#search-result").html("");
	$("#search-result").append(html);
	squareBoxProductsSearchResult();
	checkLayoutProductSearchResult();
	$("#search-result").mark(string, {
		className: "mark"
	});
}

$(window).resize(function() {
	squareBoxProductsSearchResult();
	checkLayoutProductSearchResult();
});

function squareBoxProductsSearchResult() {
	var height = $(".search-container .products .object").width();
	$(".search-container .products .object").each(function() {
		if ($(this).hasClass("empty")) {
			$(this).height(height + 3);
			if ($(this).hasClass("border-only-left")) {
				$(this).height(height + 6);
			}
		} else {
			$(this).height(height);
		}
	});
}
function removeClear() {
	$(".search-container .clear").each(function() {
		$(this).remove();
	});
}
function addClear() {
	$(".search-container .box-single-result").each(function() {
		$(this).append('<div class="clear"></div>');
	});
}
function checkLayoutProductSearchResult() {
	var windowWidth = $(window).width();

	removeEmptyProductSearchResult();
	removeClear();

	if (windowWidth > 767) {
		if (windowWidth > 991) {
			if (windowWidth > 1599) {
				addPaddingRightProductSearchResult(14);
				addPaddingBottomProductSearchResult(14);
				if (checkBorderTopContainerSearchResult(14)) {
					addEmptyProductSearchResult(14, windowWidth);
				} else {
					addOneEmptyProductSearchResult(14, windowWidth);
				}
			} else {
				addPaddingRightProductSearchResult(10);
				addPaddingBottomProductSearchResult(10);
				if (checkBorderTopContainerSearchResult(10)) {
					addEmptyProductSearchResult(10, windowWidth);
				} else {
					addOneEmptyProductSearchResult(10, windowWidth);
				}
			}
		} else {
			//ipad Landscape 33%
			addPaddingRightProductSearchResult(5);
			addPaddingBottomProductSearchResult(5);
			if (checkBorderTopContainerSearchResult(5)) {
				addEmptyProductSearchResult(5, windowWidth);
			} else {
				addOneEmptyProductSearchResult(5, windowWidth);
			}
		}
	} else {
		//ipad portrait 50%
		addPaddingRightProductSearchResult(2);
		addPaddingBottomProductSearchResult(2);
		if (checkBorderTopContainerSearchResult(2)) {
			addEmptyProductSearchResult(2, windowWidth);
		} else {
			addOneEmptyProductSearchResult(2, windowWidth);
		}
	}
	addClear();
}

function getCatName(id, what) {
	var obj = {};
	switch (what) {
		case "cat":
			product_categories.forEach(function(cate) {
				if (cate.id == id) {
					var catLinkEn = cate.acf.category_name_en
						.split("/,| /")
						.join("-")
						.split(" ")
						.join("-")
						.split("'")
						.join("-")
						.toLowerCase()
						.replace('/', '');
					var catLinkIt = cate.acf.category_name_it
						.split("/,| /")
						.join("-")
						.split(" ")
						.join("-")
						.split("'")
						.join("-")
						.toLowerCase()
						.replace('/', '');
					obj = {
						it: catLinkIt,
						en: catLinkEn
					};
				}
			});
			break;
		case "sub":
			product_subcategories.forEach(function(sub) {
				if ((sub.id = id)) {
					var catLinkEn = sub.acf.sub_category_name_en
						.split("/,| /")
						.join("-")
						.split(" ")
						.join("-")
						.split("'")
						.join("-")
						.toLowerCase()
						.replace('/', '');
					var catLinkIt = sub.acf.sub_category_name_it
						.split("/,| /")
						.join("-")
						.split(" ")
						.join("-")
						.split("'")
						.join("-")
						.toLowerCase()
						.replace('/', '');
					obj = {
						it: catLinkIt,
						en: catLinkEn
					};
				}
			});
			break;
		default:
	}
	return obj;
}

function removeEmptyProductSearchResult() {
	$(".search-container .products .object").each(function() {
		$(this).removeClass("border-bottom");
		$(this).removeClass("border-right");
		if ($(this).hasClass("empty")) {
			$(this).remove();
		}
	});
}

function addPaddingRightProductSearchResult(numbToAdd) {
	var borderRightToAdd =
		parseInt(numberProductResult % numbToAdd) +
		parseInt(numberProductResult / numbToAdd);
	var c = 1;
	$(".search-container .products .object").each(function() {
		if (c % numbToAdd == 0) {
			$(this).addClass("border-right");
		}
		c++;
	});
}

function addPaddingBottomProductSearchResult(numbToAdd) {
	var borderBottomToAdd = parseInt(numberProductResult % numbToAdd);

	if (numbToAdd == 1) {
		borderBottomToAdd++;
	}
	if (!borderBottomToAdd) {
		borderBottomToAdd = numbToAdd;
	}

	$(
		$(".search-container .products .object")
			.get()
			.reverse()
	).each(function() {
		if (borderBottomToAdd) {
			$(this).addClass("border-bottom");
			borderBottomToAdd--;
		}
	});
	squareBoxProductsSearchResult();
}

function checkBorderTopContainerSearchResult(nForLine) {
	if (nForLine > numberProductResult) {
		return false;
	} else {
		return true;
	}
}

function addEmptyProductSearchResult(divider, windowWidth) {
	var mod = numberProductResult % divider;
	if (mod != 0) {
		var divToAdd = divider - mod;
		var html = "";
		for (var i = 0; i < divToAdd; i++) {
			if (i == 0) {
				html += "<div class='empty object border-left'></div>";
			} else {
				html += "<div class='empty object'></div>";
			}
		}

		$(".search-container .products .box-single-result").append(html);
		squareBoxProductsSearchResult();
	}
}

function addOneEmptyProductSearchResult(divider, windowWidth) {
	var html = "<div class='empty object border-only-left'></div>";
	$(".search-container .products .box-single-result").append(html);
	squareBoxProductsSearchResult();
}

$("#search-result").on("click tap", ".jolly, .object", function() {
	window.location = $(this).data("url");
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/partials/_search-bar.js
// module id = 17
// module chunks = 0